import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BadgeCheck, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";

export default function CoachReadyVerify() {
  const { id } = useParams();
  const [c, setC] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/coach-ready/verify/${id}`).then(({ data }) => setC(data)).catch(() => setMissing(true));
  }, [id]);
  return (
    <div className="max-w-xl mx-auto px-4 py-16 sm:py-24" data-testid="cr-verify-page">
      <Seo title="Certificate check" brand="VoluntoldHQ" path={`/coach-ready/verify/${id}`} noindex />
      {!c && !missing && <div className="flex justify-center"><Loader2 className="animate-spin" size={32} /></div>}
      {missing && (
        <div className="border-2 border-[#D3CFC0] bg-white p-6 text-center" data-testid="cr-verify-missing">
          <p className="font-head uppercase text-2xl text-[#1E1E1E]">Certificate not found</p>
          <p className="mt-2 text-sm text-[#3A3A3A]">We couldn&apos;t find a Coach Ready certificate with ID {id}. Check the ID and try again.</p>
        </div>
      )}
      {c && (
        <div className="border-2 border-[#1E1E1E] bg-white p-6 sm:p-8 text-center" data-testid="cr-verify-card">
          <BadgeCheck size={40} className="mx-auto text-[#2F7A4B]" />
          <p className="mt-3 kicker" style={{ color: "#DB9130" }}>Certificate of completion · <span className="whitespace-nowrap">ID {c.id}</span></p>
          <p className="mt-3 text-3xl sm:text-4xl text-[#1E1E1E] italic" style={{ fontFamily: "'Times New Roman', 'Liberation Serif', serif" }} data-testid="cr-verify-name">{c.name}</p>
          <p className="mt-3 text-[#1E1E1E] font-bold" data-testid="cr-verify-program">{c.program}</p>
          <p className="mt-1 text-sm text-[#3A3A3A]" data-testid="cr-verify-date">{c.completed_date}</p>
          <p className="mt-6 text-xs text-[#6E6E6E]">This confirms completion of an educational program. It is not a coaching certification, license or credential.</p>
        </div>
      )}
    </div>
  );
}
